import React from 'react';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import Routes from './Routes';
import { SnackbarProvider } from 'notistack';

import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'leaflet/dist/leaflet.css';
import 'assets/css/index.css';
import 'swiper/css';
import 'aos/dist/aos.css';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import GoogleAnalytics from 'GoogleAnalytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA7Lf6Mxbnis46li_6h3lL1fjRlQDq6dS8",
  authDomain: "sci-sab.firebaseapp.com",
  projectId: "sci-sab",
  storageBucket: "sci-sab.firebasestorage.app",
  messagingSenderId: "913128804381",
  appId: "1:913128804381:web:79a0fc72794a269fb536f4",
  measurementId: "G-N4WHEWHKS3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const App = () => {
  return (
    <SnackbarProvider maxSnack={1}>
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes />
      </BrowserRouter>
    </SnackbarProvider>
  );
}

export default App;



